import { NgModule } from '@angular/core';

import { ChartFrameComponent } from './chart-frame.component';

@NgModule({
  declarations: [ChartFrameComponent],
  exports: [ChartFrameComponent]
})
export class ChartFrameModule { }
